export default "__VITE_ASSET__8j5V16Qs__"